import { BasicUserInfo } from '@shared/models/user.models';
import { VisitorBooking } from "../../company-movements/components/visitor-booking/data/visitor-booking-service";


export interface HospitalityOrderItem {
  id?: number;
  officeId: number;
  label: string;
  description: string;
  enabled: boolean;
  price: number;
  currency: string;
}

export interface HospitalityOrderItemWithQuantity extends HospitalityOrderItem {
  quantity: number;
  menuItemId?: number;
}


export interface HospitalityInfo {
  orderItems: HospitalityOrderItem[];
  usersToNotify: BasicUserInfo[];
}

export interface SpecialHospitalityItem {
  id: number;
  description: string;
  quantity: number;
  price: number;
}

interface HospitalityOrderItemWithQuantityRequest {
  id: number;
  quantity: number;
}

export interface HospitalityBookingRequest {
  instructions?: string;
  deliveryDateTime?: string;
  menuItems: HospitalityOrderItemWithQuantityRequest[];
  specialMenuItems: SpecialHospitalityItem[];
  visitors: VisitorBooking[];
  attendees: string[];
  costCenter?: string;
}

interface HospitalOrderedItem {
  orderItemId: number;
  itemId: number;
  label: string;
  quantity: number;
  price: number;
  totalCost: number;
}

interface HospitalSpecialOrderedItem {
  orderId: number;
  label: string;
  quantity: number;
  price: number;
  totalCost: number;
}

export interface HospitalityMeetingBookingSummary {
  meetingBookingId: number;
  meetingRoomId: string;
  fromDateTime: string;
  toDateTime: string;
  meetingRoomName: string;
  officeName: string;
  meetingOwnerName: string;
  meetingOwnerUserId: string;
  status: HospitalityActionState;
  instructions: string;
  orderedItem: HospitalOrderedItem[];
  specialOrderedItem: HospitalSpecialOrderedItem[];
}

export enum HospitalityActionState {
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS',
  Done = 'DONE'
}
